import { DataRequest } from 'hooks/useDataRequest';

export const decorateSubTableDataRequest = (dataRequest: DataRequest, marketplace: string) => ({
  ...dataRequest,
  filters: {
    ...dataRequest.filters,
    marketplaces: [marketplace],
  },
});
